import { ProductFields } from "@tenforce/product-fields"
import {
    formatFileSize,
    isImage,
} from "../../components/fields/components/attachments/utils"
import env from "../../env"
import { formatDateTimeStringFromISO } from "./dateTimeParsing"
import { AttachmentDTO } from "../models/attachments"
import { IUserFormattingSettings } from "../../components/applicationheader/components/usermenu"
import { apiPath } from "../api/data"

export function convertToProductFieldAttachment(
    attachment: AttachmentDTO,
    creator: string | undefined,
    userFormattingSettings: IUserFormattingSettings,
): ProductFields.Attachment {
    return {
        id: attachment.Id,
        creator: creator,
        description: attachment.Description,
        fileName: attachment.FileName,
        fileProperties: `${formatDateTimeStringFromISO(
            attachment.CreatedOn,
            userFormattingSettings,
        )} · ${formatFileSize(attachment.FileSize)}`,
        thumbnail: isImage(attachment.FileName)
            ? `${env.applicationPath}/${apiPath}/Attachments(${attachment.Id})/Thumbnail`
            : "",
        url: `${env.applicationPath}/${apiPath}/Attachments(${attachment.Id})/$Value`,
    }
}
